import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import _ from 'lodash'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardBody from "components/Card/CardBody.jsx";


import ResetPasswordPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import { crmValidator, alert } from 'helpers';
import { authActions } from 'actions';
import { loaderActions } from 'actions';

import i18n from 'i18n';

const FORM_NAME = 'resetPasswordForm';
const form_validate = {
  "resetPasswordText": {
    rules: {
      required: true,
    },
    messages: {
      required: 'reset code is required'
    },
    alert: 'reset code is required'
  },
  "password": {
    rules: {
      required: true,
      passwordStrength: true
    },
    messages: {
      required: 'warning_messages.password_is_required',
      passwordStrength: 'password must be 1 Upper, 1 lower, 1 specialchar and 1 number and morethan 8 char'
    },
    alert: 'warning_messages.password_is_required'
  },
  "confirmPassword": {
    rules: {
      required: true,
      passwordStrength: true,
      equalTo: 'password'
    },
    messages: {
      required: 'confirm password is required',
      passwordStrength: 'password must be 1 Upper, 1 lower, 1 specialchar and 1 number and morethan 8 char',
      equalTo: 'กรุณากรอกรหัสผ่านให้ตรงกัน'
    },
    alert: 'confirm password is required'
  }
}

const validate = values => {
  const errors = crmValidator.validateByRulesList(form_validate, values);
  return errors
}

class ResetPasswordPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden"
    };

    this.props.dispatch(authActions.logout());
  }

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
    this.getEnvConfig()
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  handleSubmit = (values) => {
    const resetPasswordText = values.resetPasswordText;
    const password = values.password;
    const confirmPassword = values.confirmPassword;
    const { dispatch } = this.props;
    dispatch(authActions.ResetPassword(resetPasswordText, password, confirmPassword));
  }

  getEnvConfig() {
    const { dispatch } = this.props;
    dispatch(loaderActions.getConfig());
  }

  render() {
    const { handleSubmit, submitting, classes, pristine, dispatch, envConfig } = this.props;
    let appEnv = _.get(envConfig, 'APP_ENV') ? _.get(envConfig, 'APP_ENV') : ""
    return (
      <>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={7} md={4}>
            <form onSubmit={handleSubmit(this.handleSubmit)} name={FORM_NAME}>
                <Card login className={classes[this.state.cardAnimaton]}>
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <img src={"/images/egg-logo-text.svg"} width="80" alt=""></img>
                    <div style={{ textAlign: "center", marginTop: "20px", color: "#999" }}>เปลี่ยนรหัสผ่าน</div>
                  </div>
                  <CardBody style={{ paddingTop: "0px" }}>

                    <Field
                      name="resetPasswordText"
                      component={CustomInput}
                      type="text"
                      labelText='Reset code'
                      id="resetPasswordText"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />

                    <Field
                      name="password"
                      component={CustomInput}
                      type="password"
                      labelText={i18n.t("label.password")}
                      id="password"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputAdornmentIcon}>
                              lock_outline
                          </Icon>
                          </InputAdornment>
                        )
                      }}
                    />

                    <Field
                      name="confirmPassword"
                      component={CustomInput}
                      type="password"
                      labelText='Confirm password'
                      id="confirmPassword"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputAdornmentIcon}>
                              lock_outline
                          </Icon>
                          </InputAdornment>
                        )
                      }}
                    />

                    <Button id="btn_login" color="primary" type="submit" fullWidth={true} disabled={submitting}>
                      Submit
                    </Button>

                  </CardBody>
                  <CardFooter className={classes.justifyContentCenter}></CardFooter>
                </Card>
              </form>
            </GridItem>
          </GridContainer>
        </div>
      </>
    );
  }
}

ResetPasswordPage.propTypes = {
  classes: PropTypes.object.isRequired
};

ResetPasswordPage = reduxForm({
  form: FORM_NAME,
  validate: validate,
  enableReinitialize: true,
  onSubmitFail: (errors, dispatch, props) => {
    crmValidator.alertFirstInvalid(FORM_NAME, errors, form_validate, i18n.t('warning_messages.resetPasswordText_is_required'));
  }
})(ResetPasswordPage);

function mapStateToProps(state) {
  const { loader, envConfig } = state.loader;
  const formValues = getFormValues(FORM_NAME)(state)
  return { loader, formValues, envConfig };
}

const connectApp = connect(mapStateToProps)(withStyles(ResetPasswordPageStyle)(ResetPasswordPage));

export { connectApp as ResetPasswordPage }
